import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-apollo';
import styled from '@emotion/styled';
import { AddCircle } from '@material-ui/icons';
import { BoxDismissIcon } from '../../../../components/icons';
import Button from '../../../../components/button';
import InputSearch from '../../../../components/input/Input';
import {
  EmptyListContainer,
  EmptyListIconContainer,
  HeaderList,
  HeaderListTitle,
} from '../../styled';
import { ModalPlano } from './components/modal-plano';
import Notification from '../../../../components/notification/Notification';
import { notificationDefault } from '../../constants';

import { FIND_ALL_PLANO_VIZI, FIND_WHITE_LABEL } from '../../../../graphql/queryes';
import { CardPlano } from './components/card-plano';
import { useDebounce } from '../../../../hooks/useDebounce';
import { findAllPlanoVizi } from '../../../../services/vizi-planos';
import { ModalProcedimentos } from './components/modal-procedimentos';

export const PlanosList = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openModalProcedimentos, setOpenModalProcedimentos] = useState(false);
  const [notification, setNotification] = useState(notificationDefault);
  const [planoSelecionado, setPlanoSelecionado] = useState(null);
  const [titulo, setTitulo] = useState(null);
  const [planos, setPlanos] = useState([]);
  const [loading, setLoading] = useState(false);

  const { data, loading:loadingWhiteLabel } = useQuery(FIND_WHITE_LABEL)
  const whitelabel = data?.findEntidadeLogada?.whitelabel?.nome
  const getPlanos = async (variables) => {
    try {
      setLoading(true);
      const response = await findAllPlanoVizi(variables,whitelabel);
      setPlanos(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getPlanos({
      id: '',
    });
  }, [whitelabel]);

  useDebounce(
    titulo,
    () =>
      getPlanos({
        titulo: titulo,
      }),
    500
  );

  const onCloseModal = () => {
    setOpenModal(false);
  };
  const onCloseProcedimentosModal = () => {
    setOpenModalProcedimentos(false);
    setPlanoSelecionado(null);
  };

  const onClickAddPlano = () => {
    setPlanoSelecionado(null);
    setOpenModal(true);
  };

  const handleSearchTextChange = (e) => {
    const text = e.target.value;
    setTitulo(text);
  };

  const handlePlano = (plano) => {
    setPlanoSelecionado(plano);
    setOpenModal(true);
  };

  const handleClickProcedimentos = (event, plano) => {
    event.stopPropagation();
    setOpenModalProcedimentos(true);
    setPlanoSelecionado(plano);
  };
  const renderPlanos = () => {
    return planos?.map((plano) => {
      return (
        <CardPlano
          clickButton={(event) => handleClickProcedimentos(event, plano)}
          onClick={() => handlePlano(plano)}
          key={plano.id}
          plano={plano}
        />
      );
    });
  };

  return (
    <section>
      <HeaderList>
        <SearchContainer>
          <InputSearch
            placeholder="Buscar por título"
            classInputRoot={{
              width: '100%',
            }}
            class
            onChange={handleSearchTextChange}
            value={titulo}
          />
          <Button onClick={onClickAddPlano}>
            Criar plano
            <AddCircle />
          </Button>
        </SearchContainer>
      </HeaderList>
      <HeaderListTitle>Planos</HeaderListTitle>
      {planos?.length > 0 && <ContentCards>{renderPlanos()}</ContentCards>}
      {!loading &&  !loadingWhiteLabel && planos.length === 0 && (
        <EmptyListContainer>
          <EmptyListIconContainer>
            <BoxDismissIcon />
          </EmptyListIconContainer>
          <p>Nenhum plano foi criado</p>
          <Button onClick={onClickAddPlano}>
            Criar plano
            <AddCircle />
          </Button>
        </EmptyListContainer>
      )}
      {loading && loadingWhiteLabel && <div> Carregando... </div>}
      {openModal && (
        <ModalPlano
          plano={planoSelecionado}
          openModal={openModal}
          onCloseModal={onCloseModal}
          setNotification={setNotification}
          carregarPlanos={() => getPlanos({ titulo: '' })}
          whitelabel={whitelabel}
        />
      )}
      {openModalProcedimentos && (
        <ModalProcedimentos
          plano={planoSelecionado}
          openModal={openModalProcedimentos}
          onCloseModal={onCloseProcedimentosModal}
          setNotification={setNotification}
          carregarPlanos={() => getPlanos({ titulo: '' })}
          whitelabel={whitelabel}
        />
      )}
      <Notification
        close={() => setNotification(notificationDefault)}
        reset={() => setNotification(notificationDefault)}
        isOpen={notification.isOpen}
        variant={notification.variant}
        message={notification.message}
      />
    </section>
  );
};

const SearchContainer = styled.div`
  background-color: #fff;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 16px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  items-align: center;
  justify-content: space-between;
  margin-bottom: 10px;
  margin-top: 10px;
  gap: 5px;
  & > div {
    max-width: 100%;
    & > div {
      width: 500px;
    }
  }
`;
const ContentCards = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  flex-wrap: wrap;
  overflow-y: auto;
  max-height: 545px;
  height: calc(100vh - 300px);
`;
